var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-form" },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-col": _vm.labelCol,
            "wrapper-col": _vm.wrapperCol,
          },
        },
        [
          _c("a-ext-upload"),
          _c(
            "a-form-model-item",
            { ref: "name", attrs: { label: "字段1", prop: "field1" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入文本框内容" },
                on: {
                  blur: function () {
                    _vm.$refs.name.onFieldBlur()
                  },
                },
                model: {
                  value: _vm.form.field1,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "field1", $$v)
                  },
                  expression: "form.field1",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "字段2" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入密码333", autocomplete: "off" },
                model: {
                  value: _vm.sss,
                  callback: function ($$v) {
                    _vm.sss = $$v
                  },
                  expression: "sss",
                },
              }),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { prop: "fieldArr" } },
                    [
                      _c("a-ext-task-s-k-d-pick-and-check", {
                        model: {
                          value: _vm.form.fieldArr,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "fieldArr", $$v)
                          },
                          expression: "form.fieldArr",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "9999999" } },
                    [
                      _c("a-ext-array-edit-demo", {
                        model: {
                          value: _vm.form.fieldArr,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "fieldArr", $$v)
                          },
                          expression: "form.fieldArr",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "吱吱吱吱艾孜孜 ", prop: "fieldObj" } },
                    [
                      _c("objdemo", {
                        model: {
                          value: _vm.form.fieldObj,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "fieldObj", $$v)
                          },
                          expression: "form.fieldObj",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "字段332" } },
            [
              _c("a-input", {
                attrs: {
                  type: "password",
                  placeholder: "请输入密码",
                  autocomplete: "off",
                },
                model: {
                  value: _vm.form.field2,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "field2", $$v)
                  },
                  expression: "form.field2",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "字段3", prop: "field3" } },
            [
              _c("a-input", {
                attrs: {
                  type: "password",
                  placeholder: "请再次输入密码",
                  autocomplete: "off",
                },
                model: {
                  value: _vm.form.field3,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "field3", $$v)
                  },
                  expression: "form.field3",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "字段4", prop: "field4" } },
            [
              _c("a-cascader", {
                attrs: {
                  options: _vm.field4Options,
                  placeholder: "请选择级联选择内容",
                },
                model: {
                  value: _vm.form.field4,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "field4", $$v)
                  },
                  expression: "form.field4",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "字段10", prop: "field10" } },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择下拉框数据" },
                  model: {
                    value: _vm.form.field10,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "field10", $$v)
                    },
                    expression: "form.field10",
                  },
                },
                _vm._l(_vm.field10Options, function (item) {
                  return _c(
                    "a-select-option",
                    { key: item.value, attrs: { value: item.value } },
                    [_vm._v(" " + _vm._s(item.label) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "字段11", prop: "field11" } },
            [
              _c(
                "a-auto-complete",
                {
                  attrs: { placeholder: "请输入网址" },
                  on: { change: _vm.handleWebsiteChange },
                  model: {
                    value: _vm.form.field11,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "field11", $$v)
                    },
                    expression: "form.field11",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "dataSource" },
                    _vm._l(_vm.autoCompleteResult, function (website) {
                      return _c("a-select-option", { key: website }, [
                        _vm._v(" " + _vm._s(website) + " "),
                      ])
                    }),
                    1
                  ),
                  _c("a-input"),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { "wrapper-col": { span: 14, offset: 4 } } },
            [
              _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "perm",
                      rawName: "v-perm",
                      value: "ssss",
                      expression: "'ssss'",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(" 提交 ")]
              ),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  on: { click: _vm.resetForm },
                },
                [_vm._v(" 重置 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.testvis
        ? _c("form-model", {
            attrs: { visible: _vm.testvis },
            on: {
              "update:visible": function ($event) {
                _vm.testvis = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }